
import { LitElement, svg, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BaseMdElement } from '../base-lit-element';
import { iconClass } from '../../directives/icon-class.directive';
import { BaseIcon } from './base-icon.mixin';

// keep in synk global.d.ts
@customElement('md-icon-doc')
export class IconDoc extends BaseIcon(BaseMdElement(LitElement)) {

  constructor() {
    super();

    this.smallSvgIcon = svg`
      <svg ${iconClass(this)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path d="M4.17,2.41V17.59H15.83V6.32l-4-3.91Zm1,14.18V3.41h6.07V7h3.59v9.58Z"/>
        <g>
          <rect x="6.68" y="12.38" width="6.64" height="1"/>
          <rect x="6.68" y="9.42" width="3.29" height="1"/>
        </g>
      </svg>`;

    this.largeSvgIcon = svg`
      <svg ${iconClass(this)} xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
        <g>
          <path d="M37.67,8.32H13.93V55.68H50.07V20.49ZM15.93,53.68V10.32h20.4V22.07H48.07V53.68Z"/>
          <rect x="21.37" y="29.17" width="10.55" height="2"/>
          <rect x="21.37" y="35.5" width="21.25" height="2"/>
          <rect x="21.37" y="41.84" width="21.25" height="2"/>
        </g>
      </svg>`;
  }

  render(): TemplateResult {
    return this.renderIcon();
  }
}
